import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export const emptyItem = () => ({
  key: crypto.randomUUID(),
  kind: "product",
  description: "",
  hsn: "",
  qty: 1,
  rate: 0,
  gst_rate: 18,
});

export const ItemsEditor = ({ items, setItems, showKind = false }) => {
  const update = (i, key, value) => {
    const next = [...items];
    next[i] = { ...next[i], [key]: value };
    setItems(next);
  };

  return (
    <div className="space-y-2">
      {items.map((item, i) => (
        <div key={item.key} data-testid={`item-row-${i}`} className="grid grid-cols-12 items-center gap-2">
          {showKind && (
            <Select value={item.kind} onValueChange={(v) => update(i, "kind", v)}>
              <SelectTrigger className="col-span-2" data-testid={`item-kind-${i}`}>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="product">Product</SelectItem>
                <SelectItem value="service">Service</SelectItem>
              </SelectContent>
            </Select>
          )}
          <Input
            className={showKind ? "col-span-3" : "col-span-4"}
            placeholder="Description"
            value={item.description}
            onChange={(e) => update(i, "description", e.target.value)}
            data-testid={`item-desc-${i}`}
          />
          <Input
            className="col-span-2"
            placeholder="HSN"
            value={item.hsn}
            onChange={(e) => update(i, "hsn", e.target.value)}
            data-testid={`item-hsn-${i}`}
          />
          <Input
            className="col-span-1"
            type="number"
            min="1"
            value={item.qty}
            onChange={(e) => update(i, "qty", Number(e.target.value))}
            data-testid={`item-qty-${i}`}
          />
          <Input
            className="col-span-2"
            type="number"
            min="0"
            placeholder="Rate"
            value={item.rate}
            onChange={(e) => update(i, "rate", Number(e.target.value))}
            data-testid={`item-rate-${i}`}
          />
          <Select value={String(item.gst_rate)} onValueChange={(v) => update(i, "gst_rate", Number(v))}>
            <SelectTrigger className={showKind ? "col-span-2" : "col-span-2"} data-testid={`item-gst-${i}`}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {[0, 5, 12, 18, 28].map((r) => (
                <SelectItem key={r} value={String(r)}>{r}% GST</SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="col-span-1"
            onClick={() => setItems(items.filter((_, j) => j !== i))}
            data-testid={`item-remove-${i}`}
            aria-label="Remove item"
          >
            <Trash2 className="h-4 w-4 text-destructive" />
          </Button>
        </div>
      ))}
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="gap-1"
        onClick={() => setItems([...items, emptyItem()])}
        data-testid="add-item-button"
      >
        <Plus className="h-4 w-4" /> Add Item
      </Button>
    </div>
  );
};
